import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { guid } from '@common/Guid';
import { ICommandBase } from '@Quest/cqrs';
import { CapexAccountEditorFormSubmitEventPayload, CapexAccountEditorViewModel } from '@Quest/Financials/Capex/Components/CapexAccountEditor';
import CapexAccountEditor from '@Quest/Financials/Capex/Components/CapexAccountEditor.vue';
import { CreateCapexAccountCommandV1, DeleteCapexAccountCommandV1, UpdateCapexAccountCommandV1 } from '@Quest/Financials/Capex/Domain/commands-core';
import CapexCommands from '@Quest/Financials/Capex/Domain/commands-vue-component';
import CapexQueries from '@Quest/Financials/Capex/Domain/queries-vue-component';
import { CapexAccountReadModel, CapexAccountsReadModel } from '@Quest/Financials/Capex/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({ components: { CorporateNavigation, CapexAccountEditor } })
export default class CapexPage extends mixins(CapexQueries, CapexCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: CapexAccountsReadModel | null = null;
    capexAccountEditor: CapexAccountEditorViewModel = new CapexAccountEditorViewModel();

    get accounts(): CapexAccountReadModel[] { return this.rm?.Accounts ?? []; }

    mounted()
    {
        document.title = "Capex | TransparentChoice";
        this.runCapexAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
    }

    showCapexCreator()
    {
        this.capexAccountEditor.showCreator();
    }

    showCapexEditor(c: CapexAccountReadModel)
    {
        this.capexAccountEditor.showEditor(c.Id, c.Name, c.Description, c.Classification);
    }

    handleCapexAccountEditorFormSubmit(e: CapexAccountEditorFormSubmitEventPayload)
    {
        if (e.id == null)
        {
            this.invokeCreateCapexAccountCommandV1(this.workspaceId, this.strategyId, guid(), e.name, e.description, e.classification);
        }
        else
        {
            this.invokeUpdateCapexAccountCommandV1(this.workspaceId, this.strategyId, e.id, e.name, e.description, e.classification);
        }
    }

    handleDeleteCapexAccountCommand(capex: CapexAccountReadModel)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteCapexAccountCommandV1(this.workspaceId, this.strategyId, capex.Id);
        }
    }


    onSetModel(model: any, modelName: string)
    {
        if (modelName === "CapexAccountsReadModel")
        {
            this.rm = model as CapexAccountsReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (CreateCapexAccountCommandV1.matchType(cmd))
        {
            this.runCapexAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
            this.capexAccountEditor.close();
        }
        else if (UpdateCapexAccountCommandV1.matchType(cmd))
        {
            this.runCapexAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
            this.capexAccountEditor.close();
        }
        else if (DeleteCapexAccountCommandV1.matchType(cmd))
        {
            this.runCapexAccountsByStrategyIdQueryV1(this.workspaceId, this.strategyId);
            this.capexAccountEditor.close();
        }
    }
}